exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms-box input[type=checkbox]:checked~label,.terms-box input[type=checkbox]:not(:checked)~label{margin:0 0 5px 40px}.terms-box .message{color:#b8ff9f}.terms-box.error .message{color:#ff9f9f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/terms/terms.styl
// module id = 145
// module chunks = 0 1